export enum ProfitSharingStatusEnum {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

export enum ProfitSharingModeEnum {
  VIEW = 'VIEW',
  EDIT = 'EDIT'
}
